export const ShopifyRoutes = {
    shopifyShops: '/shopify-shops',
    shopify: '/shopify',
} as const;
